import { type } from './type.js';

/**
 * @description
 * Checks if `value` is classified as an `ArrayBuffer` object.
 *
 * @example
 * ``` ts
 * isArrayBuffer(new ArrayBuffer(2));
 * // => true
 * isArrayBuffer(new Array(2));
 * // => false
 * ```
 *
 * @param value The value to check.
 * @returns Returns true if value is an array buffer, else false.
 *
 * @docsCategory preference/lang
 * @codeFilter is-array-buffer
 */
export const isArrayBuffer = (value): value is ArrayBuffer => {
  return type(value) === 'arrayBuffer';
};
